<p-table
  #dt
  [value]="data"
  [selection]="selection"
  (selectionChange)="selectionChange.emit($event)"
  [paginator]="true"
  [rows]="rows"
  [rowsPerPageOptions]="rowsPerPageOptions"
  [globalFilterFields]="globalFilterFields"
  responsiveLayout="scroll"
>


  <!-- HEADER -->
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 40px">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>

      <th *ngFor="let col of columns">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>

  <!-- BODY -->
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>
        <p-tableCheckbox [value]="row"></p-tableCheckbox>
      </td>

      <td *ngFor="let col of columns">
        <!-- CUSTOM TEMPLATE -->
        <ng-container *ngIf="col.type === 'custom'; else defaultCell">
          <ng-content
            select="[tableCell={{ col.field }}]"
            [ngTemplateOutletContext]="{ $implicit: row }"
          ></ng-content>
        </ng-container>

        <!-- DEFAULT -->
        <ng-template #defaultCell>
          {{ row[col.field] }}
        </ng-template>
      </td>
    </tr>
  </ng-template>
</p-table>

